import { render, staticRenderFns } from "./ShopWifi.vue?vue&type=template&id=f340f03e&scoped=true&"
import script from "./ShopWifi.vue?vue&type=script&lang=js&"
export * from "./ShopWifi.vue?vue&type=script&lang=js&"
import style0 from "./ShopWifi.vue?vue&type=style&index=0&id=f340f03e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f340f03e",
  null
  
)

export default component.exports